import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const WrongPathRedirect = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(15);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 15000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  return (
    <div className="wrongpath-wrapper">
      <div className="wrongpath-container">
        {/* Decorative background elements */}
        <div className="wrongpath-bg-blob wrongpath-bg-blob-1"></div>
        <div className="wrongpath-bg-blob wrongpath-bg-blob-2"></div>

        <div className="wrongpath-card">
          {/* 404 Icon */}
          <div className="wrongpath-icon-wrapper">
            <div className="wrongpath-icon-circle">
              <svg
                className="wrongpath-icon-svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
          </div>

          <h1 className="wrongpath-title">
            <span className="gradientText">404</span>
            <span className="wrongpath-title-text">Page Not Found</span>
          </h1>

          <div className="wrongpath-content">
            <p className="wrongpath-text wrongpath-text-primary">
              Oops! This page has moved or is no longer available.
            </p>

            <p className="wrongpath-text wrongpath-text-secondary">
              We've recently updated our website to better serve you. Some older
              links may not work anymore.
            </p>

            {/* Progress bar for redirect */}
            <div className="wrongpath-progress-wrapper">
              <div className="wrongpath-progress-label">
                <span>Redirecting to homepage</span>
                <span className="wrongpath-count">{count}s</span>
              </div>
              <div className="wrongpath-progress-track">
                <div
                  className="wrongpath-progress-bar"
                  style={{ width: `${((15 - count) / 15) * 100}%` }}
                />
              </div>
            </div>

            <div className="wrongpath-actions">
              <button
                className="wrongpath-button wrongpath-button-primary"
                onClick={() => navigate("/")}
              >
                <svg
                  className="wrongpath-button-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Go to Homepage
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WrongPathRedirect;